<template>

    <header class="header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 d-flex justify-content-between">
                    <div class="leftbarIcon mobile" @click="$emit('toggleSidebar')">
                        <span></span><span></span><span></span>
                    </div>
                    <div class="globlalActionsHolder d-flex align-items-center justify-content-between">
                        <div class="globalSearch d-flex align-items-center justify-content-between">
                            <div class="search d-flex align-items-center justify-content-between">
                                <form action="/">
                                    <input type="text" class="w-100" id="inputSearch" placeholder="Search ..." value="">
                                </form>
                                <button type="search"><i class="fas fa-search"></i></button>
                            </div>

                            <!--<div class="bx-time" id="timeman-timer">
                                <span class="time-hours">{{hh}}</span>
                                <span class="time-semicolon">:</span>
                                <span class="time-minutes">{{mm}}</span>
                                <span class="time-am-pm">{{md}}</span>
                            </div>-->

                        </div>
                        <div>
                            <div class="d-flex align-items-center justify-content-end">
                                <div class="mx-2 dropdown">
                                    <select class="form-select form-select-sm me-2" v-model="userBranch" @change="updateBranch(userBranch)">
                                        <option v-for="branch in branchLists" :value="branch.id">{{branch.name}}</option>
                                    </select>
                                </div>

                                <div class="mx-2">
                                    <a href="/help/training-guide.html" target="_blank" rel="noopener"
                                        title="Help — Training Guide" aria-label="Help — Training Guide">
                                        <i class="fa-solid fa-circle-question"></i>
                                    </a>
                                </div>

                                <div class="themeColor mx-2 dropdown">
                                    <div class="dropdown-toggle" data-bs-toggle="dropdown">
                                        <i id="dropdownToggle" class="fa-solid fa-palette"></i>
                                    </div>

                                    <ul class="dropdown-menu">
                                        <li><a href="javascript:void(0)" class="ps-2 pe-2 pb-2">Color Scheme</a></li>
                                        <li id="theme_04" class="themes">
                                            <a class="p-2" href="javascript:void(0);" @click="setThemeStyle('theme_04')">
                                                <span class="color_04"></span>
                                                <span class="icon">
                                                    <img :src="current_url+'/assets/images/inner_bg04.jpg'" alt="theme">
                                                </span>
                                            </a>
                                        </li>
                                        <li id="theme_01" class="themes">
                                            <a class="p-2" href="javascript:void(0);" @click="setThemeStyle('theme_01')">
                                                <span class="color_01"></span>
                                                <span class="icon"><img :src="current_url+'/assets/images/inner_bg01.jpg'"
                                                        alt="theme"></span>
                                                
                                            </a>
                                        </li>
                                        <li id="theme_02" class="themes">
                                            <a class="p-2" href="javascript:void(0);" @click="setThemeStyle('theme_02')">
                                                <span class="color_02"></span>
                                                <span class="icon">
                                                    <span style="width: 42px;height: 24px;background: rgba(255,235,240,0.4);border: 1px solid #606060;border-radius: 3px;"></span>
                                                    <!-- <img :src="current_url+'/assets/images/inner_bg02.jpg'" alt="theme"> -->
                                                </span>
                                            </a>
                                        </li>
                                        <li id="theme_03" class="themes">
                                            <a class="p-2" href="javascript:void(0);" @click="setThemeStyle('theme_03')">
                                                <span class="color_03"></span>
                                                <span class="icon">
                                                    <span style="width: 42px;height: 24px;background: rgba(125, 185, 70, 0.11);border: 1px solid #606060;border-radius: 3px;"></span>
                                                    <!-- <img :src="current_url+'/assets/images/inner_bg03.jpg'" alt="theme"> -->
                                                </span>
                                            </a>
                                        </li>
                                    </ul>

                                </div>

                                <div class="signoutWidget ms-2 dropdown">
                                    <div class="d-flex align-items-center justify-content-end dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                        <img :src="`${user_image}`" alt="User avatar" />
                                        <!-- <button type="button">{{ $store.state.user.name }}</button> -->
                                    </div>
                                    <ul class="dropdown-menu shadow-sm">
                                        <div class="d-flex items-center px-3 py-2 userView">
                                            <img :src="'/assets/images/profile-45x45.png'" alt="User avatar"
                                                class="me-2" />
                                            <div class="w-40">
                                                <div class="userName">{{ $store.state.user.name }}</div>
                                                <!--  <div class="userEmail">{{ $store.state.user.email }}</div> -->
                                            </div>
                                        </div>
                                        <router-link class="d-block px-4 py-2" role="menuitem" to="/modules/home"
                                            @click.native="dropdownOpen = false">
                                            <span class="icon"> <i class="fa-solid fa-gauge"></i></span>
                                            {{ $t('Dashboard') }}
                                        </router-link>
                                        <router-link class="d-block px-4 py-2" role="menuitem" to="/modules/account"
                                            @click.native="dropdownOpen = false">
                                            <span class="icon"> <i class="fa-solid fa-user"></i></span>
                                            {{ $t('Your profile') }}
                                        </router-link>
                                        <router-link class="d-block px-4 py-2"
                                            v-if="$store.state.user.is_admin === 1" role="menuitem"
                                            to="/modules/administration" @click.native="dropdownOpen = false">
                                            <span class="icon"> <i class="fa-solid fa-gear"></i></span>
                                            Admin
                                        </router-link>
                                        <router-link class="d-block px-4 py-2"
                                            v-if="$store.state.user && ($store.state.user.is_trainer == 1)" role="menuitem"
                                            to="/modules/user-roles/modify-my-role" @click.native="dropdownOpen = false">
                                            <span class="icon"> <i class="fa-solid fa-user-gear"></i></span>
                                            Modify Role
                                        </router-link>
                                        <a class="d-block px-4 py-2" href="javascript:void(0)" role="menuitem"
                                            @click.prevent="signOut">
                                            <span class="icon"> <i class="fa-solid fa-right-from-bracket"></i></span>
                                            {{ $t('Sign out') }}
                                        </a>
                                    </ul>
                                </div>
                            </div>
                            <!-- <span>You are logged in as <span class="UserName">{{ $store.state.user.name }}</span></span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway';
    import store from '@/store';

    export default {
        name: "navbar",
        mixins: [clickaway],

        data() {
            return {
                dropdownOpen: false,
                navbar: {
                    upload_nabh_logo: '',
                },
                hh: '',
                mm: '',
                md: '',
                user_image: '',
                current_url: '',
                lastTheme:'',
                branchLists:[],
                userBranch:''
            }
        },
        mounted() {
            this.getBasicInfo();
            //this.printCurrentTime();
            setInterval(() => {
                this.printCurrentTime();
                if (this.$route.path === '/modules/home') {
                    this.setBranch();
                }
            }, 1000);
            this.current_url = window.location.origin;
            this.current_url.slice(0, -1);
            this.getBranchList();
        },
        methods: {
            getBasicInfo() {
                const self = this;
                axios.get('api/pdf-settings', { params: { 'key': 'upload_nabh_logo' } }).then(function (response) {
                    self.navbar.upload_nabh_logo = response.data;
                    let userDate = JSON.parse(localStorage.getItem('user_prefrence'));
                    let liEl = document.getElementById(userDate.theme);
                    liEl.classList.add('active');
                    self.lastTheme = userDate.theme;
                    self.loading = false;
                }).catch(function () {
                    self.loading = false;
                });
            },
            async signOut() {
                this.dropdownOpen = false;
                await this.$store.commit('logout');
                const self = this;
                await axios.get('api/saml-setting-info').then(function (response) {
                    let res = response.data;
                    if(res.status!=1 || res.status!='1'){
                        self.$router.push('/auth/login');
                    }
                    self.loading = false;
                })
              //  self.$router.push('/auth/login');
            },
            setThemeStyle(themename) {
                const self = this;
                const dropdownToggle = document.getElementById('dropdownToggle');
                this.$nextTick(() => {
                    dropdownToggle.dispatchEvent(new Event('click'));
                });
                /* let lastTheme = self.lastTheme;
                let liEl1 = document.getElementById(lastTheme);
                    liEl1.classList.remove('active'); */

                axios.post('api/set-preferences', { theme: themename }).then(function (response) {
                    self.loading = false;
                    window.location.reload();
                /*  self.lastTheme = themename;
                    let liEl = document.getElementById(themename);
                    liEl.classList.add('active');

                    this.$store.commit('setUser'); */

                }).catch(function () {
                    self.loading = false;
                });
                this.$store.commit('setUser');
            },
            printCurrentTime() {
                const self = this;
                let currentdate = new Date().toLocaleTimeString();
                let currentTime = currentdate.split(":");
                let meridian = currentTime[2].split(" ");
                if (currentTime[0] < 10) {
                    self.hh = `0${currentTime[0]}`;
                } else {
                    self.hh = currentTime[0];
                }

                self.mm = currentTime[1];
                self.md = meridian[1];

                self.user_image = self.current_url + localStorage.getItem('user_image');
            },
            getBranchList(){
                const self = this;
                axios.get('api/modules/branchs/axioscall', {params:{'action':'list', 'getBranchList':true}}).then(function (response) {
                    self.branchLists = response.data.items;
                    // Prefer the server's authoritative current branch; fall back to
                    // the store only if the API didn't provide it. This keeps the
                    // dropdown selection in sync with the DB even when the client
                    // store is stale (e.g. PI users right after SAML login).
                    self.userBranch = response.data.current_branch_id
                        ? response.data.current_branch_id
                        : (self.$store.state.user ? self.$store.state.user.branch_id : '');
                }).catch(function (err) {
                    console.warn(err);
                });
            },
            updateBranch(selectedBranch){
                const self = this;
                let user = JSON.parse(localStorage.getItem('user_prefrence'));
                let branchInfo = {
                    'update_branch':true,
                    'user_id': user.id,
                    'new_branch_id':selectedBranch,
                    'user_info':user
                };
                axios.post('api/modules/branchs/axioscall', {'branch_info':branchInfo}).then(function (response) {
                    if(response.data.message == 1){
                        alert(response.data.msg);
                        self.userBranch = user.branch_id;
                    }else{
                        self.userBranch = selectedBranch
                        //self.$store.commit('login', response.data);

                        // Synchronously update the cached user's branch_id BEFORE the
                        // reload. axios.js sends current_user_branch_id from this
                        // localStorage value on every request; without this update the
                        // page could reload before the async setUser() fetch finishes,
                        // leaving list views scoped to the OLD branch.
                        try {
                            let cachedUser = JSON.parse(localStorage.getItem('user_prefrence'));
                            if (cachedUser) {
                                cachedUser.branch_id = selectedBranch;
                                localStorage.setItem('user_prefrence', JSON.stringify(cachedUser));
                            }
                        } catch (e) { /* ignore malformed cache */ }

                        self.$store.commit('setUser');
                        setTimeout(()=>{
                            if (self.$route.path === '/modules/home') {
                                self.$router.go(0);
                            } else {
                                self.$router.push('/modules/home');
                            }
                        }, 500);
                    }
                }).catch(function (err) {
                    console.warn(err);
                });
            },
            setBranch(){
                const current_user = JSON.parse(localStorage.getItem('user_prefrence'));
                // Only set from localStorage when it has a non-empty branch_id that
                // actually exists in the loaded branch list. Otherwise leave the
                // value set by getBranchList() intact — this interval used to clobber
                // a correct selection with a stale/empty localStorage value every
                // second (top bar showed empty on refresh).
                if (current_user && current_user.branch_id) {
                    const exists = this.branchLists.some(b => b.id === current_user.branch_id);
                    if (exists) {
                        this.userBranch = current_user.branch_id;
                    }
                }
            }
        }
    }
</script>
